import { render, staticRenderFns } from "./col1_2.vue?vue&type=template&id=a103f9f6&scoped=true"
import script from "./col1_2.vue?vue&type=script&lang=js"
export * from "./col1_2.vue?vue&type=script&lang=js"
import style0 from "./col1_2.vue?vue&type=style&index=0&id=a103f9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a103f9f6",
  null
  
)

export default component.exports